import { render, staticRenderFns } from "./EducationalRatingAdd.vue?vue&type=template&id=0ac7c134&"
import script from "./EducationalRatingAdd.vue?vue&type=script&lang=js&"
export * from "./EducationalRatingAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports